import React from 'react'
import {UniLink} from '../../../../core/components/unilink/index'
import {withNav} from '../../../../core/components/navbar/index'
import './editProfile.css'

const EditProfile = ({className, children, location, match}) => {
  const activePath = location.pathname.split('/').pop()
  return (
    <div className={className}>
      <div className='gridcontainer'>
        <div className='edit_profile'>
          <div className='edit-profile__sidebar'>
            <UniLink
              to={`${match.url}/account`}
              className={activePath === 'account' ? 'edit-profile__navigation edit-profile__navigation--active' : 'edit-profile__navigation'}>
              Account Info
            </UniLink>
            <hr className='edit-profile__navigation-divider' />
            <UniLink
              to={`${match.url}/password`}
              className={activePath === 'password' ? 'edit-profile__navigation edit-profile__navigation--active' : 'edit-profile__navigation'}>
              Password
            </UniLink>
            <hr className='edit-profile__navigation-divider' />
            <UniLink
              to={`${match.url}/notifications`}
              className={activePath === 'notifications' ? 'edit-profile__navigation edit-profile__navigation--active' : 'edit-profile__navigation'}>
              Notifications
            </UniLink>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default withNav(EditProfile, true)



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/components/EditProfile.js